import axios from '../axios';
import { UserNotification } from '../../models/response/notification';
import Helpers from '../../utilities/helpers';

export const ListAllNotifications = async () => {
  return await axios.get<UserNotification[]>(
    `${process.env.REACT_APP_BASE_URL}/user/notification/web`,
    {
      headers: {
        'accept-language': Helpers.getLanguageFromUrl(
          window.location.toString()
        ),
      },
    }
  );
};

export const ReadListNotification = async (idList: number[]) => {
  return await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/user/notification/read/list`,
    idList
  );
};

export const AcceptBuyCarNotification = async (id: number) => {
  return await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/user/notification/buy-car`,
    { id }
  );
};
